import React from "react";
import { useStoreDispatch } from "../../utils/hooks/hooks";
import { setPreventClose } from "../../utils/store/reducer/slices/modalReducer";

interface TutorialModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const TutorialModal: React.FC<TutorialModalProps> = ({ isOpen, onClose }) => {
  const dispatch = useStoreDispatch();
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-6"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-5xl rounded-xl bg-white shadow-2xl"
        onClick={e => {
          e.stopPropagation();
          dispatch(setPreventClose(true));
        }}
      >
        {/* Header */}
        <div className="flex items-center justify-between border-b px-6 py-4">
          <div>
            <h3 className="text-xl font-semibold text-gray-900">Quick Product Tour</h3>
            <p className="text-sm text-gray-600">A short walkthrough of CaptureTheBug</p>
          </div>
          <button
            onClick={onClose}
            className="rounded-md p-2 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700"
            aria-label="Close tutorial"
          >
            <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        {/* Body with Supademo iframe */}
        <div className="p-0">
          <div
            style={{
              position: "relative",
              boxSizing: "content-box",
              maxHeight: "80vh",
              width: "100%",
              // Aspect ratio wide for large screens
              aspectRatio: "1.899497487437186",
              padding: "40px 0 40px 0"
            }}
          >
            <iframe
              src="https://app.supademo.com/embed/cmelhqxvv102wv9kq1zkjmv4k?embed_v=2&utm_source=embed"
              loading="lazy"
              title="Capturethebug Demo"
              allow="clipboard-write"
              frameBorder={0}
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%"
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TutorialModal;
